













































































import { Vue, Component } from "vue-property-decorator";
import TaxonomyProfessionalActivityItem from "@/components/taxonomy/ProfessionalActivityTaxonomyItem.vue";
import { TermList as ITermList } from "@/api/models/term-list";
import specialty from "@/getinfo-api/specialty";
import professionalActivity, {
  TermListParams
} from "@/getinfo-api/professionalActivity";
import professionalProrgamm from "@/getinfo-api/professionalProrgamm";
import { Term as ITerm } from "@/api/models/term";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import api from "@/getinfo-api";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";

@Component({
  components: { CField, CPage, TaxonomyProfessionalActivityItem }
})
export default class ProfessionalActivityTaxonomyList extends Vue {
  showSpinner: boolean = false;
  termList: Array<ITerm> = [];
  termCount: number = 0;
  termType: string = "activity";
  limit: number = 30;
  offset: number = 0;
  search!: string | undefined;

  data() {
    return {
      search: undefined
    };
  }

  clean() {
    this.termList = [];
    this.termCount = 0;
    this.offset = 0;
    this.search = undefined;
    this.getAllTerm();
  }

  applyFilter() {
    this.offset = 0;
    this.termList = [];
    this.showSpinner = true;
    this.getAllTerm(this.offset);
  }

  get screenWidth() {
    return window.innerWidth;
  }

  getTermByOffset() {
    this.offset += this.limit;
    this.getAllTerm(this.offset);
  }

  updateTermFromList(payload: any) {
    if (this.termType === "activity") {
      api.ProfessionalActivityTaxonomyApi.edit(payload.termId, payload.params)
        .then((res: { data: ITerm }) => {
          const index = this.termList?.findIndex(
            el => el.id === payload.termId
          );
          this.termList[index].title = res.data.title;
          this.termList[index].description = res.data.description;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
    if (this.termType === "specialty") {
      api.SpecialtyTaxonomyApi.edit(payload.termId, payload.params)
        .then((res: { data: ITerm }) => {
          const index = this.termList?.findIndex(
            el => el.id === payload.termId
          );
          this.termList[index].title = res.data.title;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
    if (this.termType === "program") {
      api.ProfessionalProgramTaxonomyApi.edit(payload.termId, payload.params)
        .then((res: { data: ITerm }) => {
          const index = this.termList?.findIndex(
            el => el.id === payload.termId
          );
          this.termList[index].title = res.data.title;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  deleteTermFromList(termId: string) {
    if (this.termType === "activity") {
      api.ProfessionalActivityTaxonomyApi._delete(termId)
        .then(() => {
          this.$store.dispatch("successToast", {
            message: this.$tc(this.$translate.SuccessfullyDeleted)
          });
          this.termList = this.termList.filter(el => el.id !== termId);
          this.termCount -= 1;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
    if (this.termType === "specialty") {
      api.SpecialtyTaxonomyApi._delete(termId)
        .then(() => {
          this.$store.dispatch("successToast", {
            message: this.$tc(this.$translate.SuccessfullyDeleted)
          });
          this.termList = this.termList.filter(el => el.id !== termId);
          this.termCount -= 1;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
    if (this.termType === "program") {
      api.ProfessionalProgramTaxonomyApi._delete(termId)
        .then(() => {
          this.$store.dispatch("successToast", {
            message: this.$tc(this.$translate.SuccessfullyDeleted)
          });
          this.termList = this.termList.filter(el => el.id !== termId);
          this.termCount -= 1;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  getMethod(termType: string, params: any) {
    let method: any;
    if (termType === "activity") method = professionalActivity(params);
    if (termType === "specialty") method = specialty(params);
    if (termType === "program") method = professionalProrgamm(params);
    return method;
  }

  getAllTerm(offset: number = 0) {
    this.showSpinner = true;

    let params: TermListParams = {
      title: this.search ? this.search : undefined,
      limit: this.limit,
      offset: offset,
      order: "DESC"
    };

    this.getMethod(this.termType, params)
      .then((res: { data: ITermList }) => {
        this.termCount = res.data.count;
        if (res.data.items) {
          res.data.items.forEach((item: ITerm) => {
            this.termList.push(item);
          });
        }
      })
      .finally(() => {
        this.showSpinner = false;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.getAllTerm();
  }
}
